module.exports = __webpack_public_path__ + "img/5.233c7fa8.jpg";